import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./SideMenu.scss";
import {
  MotifVerticalNavigationContent,
  MotifVerticalNavigationMenu,
  MotifVerticalNavigationMenuItem,
  MotifVerticalNavigation,
  MotifVerticalNavigationFooter,
} from "../../assets/lib/motif";
import { BookIcon, FolderIcon, HomeIcon, PrivacyIcon } from "../../icons";
import { routes } from "../../routes/routes.constatns";
import { releaseAlllocks } from "../../store/services/engagement.service";
import { useSelector, useDispatch } from "react-redux";
import {
  getUserConsent,
  setDefaultLoader,
} from "../../store/slices/engagementSlice";
import {
  unSetSelectedSectors,
  unsetTeamMember,
} from "../../store/slices/setupSlice";
import privacyNotice from "../../assets/templates/privacyNotice.pdf";
import { consentPrivacyText } from "../../util/constants";
import MenuHomeIcon from "../../icons/menu-home";
import MenuEngagementIcon from "../../icons/menu-engagement";
import MenuBookIcon from "../../icons/menu-book";
import { useRegRedirectionAuthTokenAPAC } from "../../hooks/useAppRedirectionTokenAPAC";
import { useRegRedirectionAuthTokenUS } from "../../hooks/useAppRedirectionTokenUS";
import { useRegRedirectionAuthTokenEU } from "../../hooks/useAppRedirectionTokenEU";

export function SideMenu({ isSideMenuCollapsed }) {
  const user = useSelector((state) => state.user.user);
  const engagementState = useSelector((state) => state.engagement);
  const dispatch = useDispatch();
  const [showDecarbLibrary, setShowDecarbLibrary] = useState(true);
  const [enableDecarbLibrary, setEnableLibrary] = useState(true);
  const { pathname } = useLocation();

  const token_APAC = useRegRedirectionAuthTokenAPAC();
  const token_US = useRegRedirectionAuthTokenUS();
  const token_EU = useRegRedirectionAuthTokenEU();

  /* istanbul ignore next */
  async function handleSideMenuClick(route) {
    dispatch(setDefaultLoader({ loader: true || engagementState.userConsentLoading }));
    await releaseAlllocks({ request: { email: user.username } });
    dispatch(setDefaultLoader({ loader: false || engagementState.userConsentLoading  }));

    // Bhushan - Resetting the state of setup slice
    dispatch(unSetSelectedSectors());
    dispatch(unsetTeamMember());
    // Bhushan - Removed reload of page as this is not required
    window.location.href = `${process.env.REACT_APP_URL_REG_ALL}${route}`;
    // navigate(`/${route}`, { gestureEnabled: false });
  }

  useEffect(() => {
    if (process.env.REACT_APP_MULTI_REGION_ALLOW !== 'true') {
      if (user?.username)
        dispatch(getUserConsent({ email: user.username })).then((data) => {
          let shouldShowLibrary = data?.payload?.externalUser;
          let shouldEnableLibrary = data?.payload?.ccassUser;
          setShowDecarbLibrary(shouldShowLibrary);
          setEnableLibrary(shouldEnableLibrary);
        });
      console.log("Multi-region is disabled. Fetched user consent for:", user?.username);
    }
  }, [dispatch, user?.username]);

  useEffect(() => {
    if (token_APAC && token_US && token_EU) {
      if (user?.username)
        dispatch(getUserConsent({
          email: user.username,
          tokenAPAC: token_APAC,
          tokenUS: token_US,
          tokenEU: token_EU
        })).then((data) => {
          let shouldShowLibrary = data?.payload?.externalUser;
          let shouldEnableLibrary = data?.payload?.ccassUser;
          setShowDecarbLibrary(shouldShowLibrary);
          setEnableLibrary(shouldEnableLibrary);
        });
      console.log("Multi-region is enabled. Fetched user consent for:", user?.username);
    }
  }, [token_APAC, token_US, token_EU, user?.username]);


  return (
    <MotifVerticalNavigation
      collapse={isSideMenuCollapsed}
      className="decarb-side-menu"
    >
      {!engagementState.userConsentLoading && <>
      <MotifVerticalNavigationContent>
        <MotifVerticalNavigationMenu>
          <MotifVerticalNavigationMenuItem
            className={[showDecarbLibrary ? "hide-decarbLibrary" : "", pathname.includes('home') ? 'side-menu-active' : '' ].join(' ')}
            icon={<MenuHomeIcon />}
            label="Home"
            onClick={() => handleSideMenuClick(routes.home)}
          >
            Home
          </MotifVerticalNavigationMenuItem>
          <MotifVerticalNavigationMenuItem
            icon={<MenuEngagementIcon />}
            label="Engagement dashboard"
            onClick={() => handleSideMenuClick(`${routes.viewEngagement}`)}
            className={pathname.includes('engagement') ? 'side-menu-active' : '' }
          >
            Engagement dashboard
          </MotifVerticalNavigationMenuItem>

          <div className={enableDecarbLibrary ? "" : "disableCursor"}>
            <MotifVerticalNavigationMenuItem
              className={showDecarbLibrary ? "hide-decarbLibrary" : enableDecarbLibrary ? "" : "disable-decarbLibrary"}
              icon={<MenuBookIcon />}
              label="Decarbonization library"
              onClick={() =>
                window.open(
                  process.env.REACT_APP_URL_REG_ALL +
                    `${routes.decarbProjectsLibrary}`,
                  "mywindow",
                  "location=0,menubar=0,status=0,scrollbars=0,width=900,height=400"
                )
              }
            >
              Decarbonization library
            </MotifVerticalNavigationMenuItem>
          </div>
        </MotifVerticalNavigationMenu>
      </MotifVerticalNavigationContent>
      <MotifVerticalNavigationFooter>
        <MotifVerticalNavigationMenu>
          <MotifVerticalNavigationMenuItem
            label={"privacyNotice"}
            icon={<PrivacyIcon />}
          >
            <a className="content-notice" href={privacyNotice} download>
              {consentPrivacyText}
            </a>
          </MotifVerticalNavigationMenuItem>
        </MotifVerticalNavigationMenu>
      </MotifVerticalNavigationFooter>
</>
}
    </MotifVerticalNavigation>
  );
}
